export default __webpack_public_path__ + "static/media/VSWaterQuantTemplate.0b322ded.xlsx";